module.exports = __webpack_public_path__ + "img/radio.1beecd54.svg";